import { OperatorEntityService } from '@views/pages/apps/superuser/operators/services/operator-entity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';

@Injectable()
export class OperatorResolver implements Resolve<boolean> {

    constructor(private operatorEntityService: OperatorEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.operatorEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.operatorEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
